<table class="table-condensed column-filters" style="margin-bottom: 0">
    @for (filter of columnFilters; track filter) {
        <tr [ngStyle]="{ display: hideRow(filter) }">
            <td class="filter-name">{{ filter.resultColumnName || filter.resultsColumnName || filter.displayName }}</td>
            <td class="filter-ors">
                <table class="table-condensed">
                    @for (or of filter.or; track or; let index = $index) {
                        <tr>
                            @if (showOrs) {
                                <td class="or-or"><span [ngClass]="{ invisible: index === 0 }">OR</span></td>
                            }
                            <td class="or-operator">
                                <ws-select
                                    [(ngModel)]="or.operator"
                                    (selectedOptionChanged)="changeOperator(filter, or, or.operator?.name)"
                                    [options]="filter.operators | sortBy: 'asc' : 'sortOrder'"
                                    labelProperty="displayName"
                                    [returnEntireOption]="true"
                                >
                                </ws-select>
                            </td>
                            <td class="or-input" [ngClass]="maybeHideValue(or.operator?.name)">
                                @switch (selectorType(filter, or.operator?.name)) {
                                    @case ('input') {
                                        <input
                                            type="text"
                                            style="transition: initial"
                                            class="form-control"
                                            [ngModel]="or.value"
                                            (ngModelChange)="updateOrValue($event, or)"
                                            maxlength="100"
                                        />
                                    }
                                    @case ('date') {
                                        <weissman-datetime
                                            [required]="false"
                                            [dateOnly]="true"
                                            [fillWidth]="true"
                                            [inputDate]="or.value || null"
                                            (inputDateChange)="updateOrValue($event, or)"
                                        >
                                        </weissman-datetime>
                                    }
                                    @case ('withinDate') {
                                        <span>
                                            <select
                                                [ngModel]="or.value"
                                                (ngModelChange)="updateOrValue($event, or)"
                                                class="form-select form-select-sm"
                                            >
                                                <option></option>
                                                <option value="30">30 Days</option>
                                                <option value="60">60 Days</option>
                                                <option value="90">90 Days</option>
                                            </select>
                                        </span>
                                    }
                                    @case ('yesNo') {
                                        <select
                                            [ngModel]="or.value"
                                            (ngModelChange)="updateOrValue($event, or)"
                                            class="form-select form-select-sm"
                                        >
                                            <option value=""></option>
                                            <option value="yes">Yes</option>
                                            <option value="no">No</option>
                                        </select>
                                    }
                                    @case ('company') {
                                        <ws-company-picker
                                            [companyName]="or.value"
                                            (companyNameChange)="updateOrValue($event, or)"
                                            [appendToBody]="true"
                                            [topLevelOnly]="
                                                (filter.columnId || filter.id || filter.advancedSearchFieldID) ===
                                                COMPANY_NAME_TOP_LEVEL_ID
                                            "
                                            [activeOnly]="activeOnly"
                                            [favoritesOnly]="onlyFrequentlyUsedCompanies"
                                        >
                                        </ws-company-picker>
                                    }
                                    @case ('casePriority') {
                                        <select
                                            [ngModel]="or.value"
                                            (ngModelChange)="updateOrValue($event, or)"
                                            class="form-select form-select-sm"
                                        >
                                            <option value=""></option>
                                            <option value="standard">Standard</option>
                                            <option value="expedited">Expedited</option>
                                            <option value="emergency">Emergency</option>
                                        </select>
                                    }
                                }
                            </td>
                            @if (!hideDelete || index > 0) {
                                <td class="or-delete">
                                    <button
                                        type="button"
                                        class="ace-btn has-icon btn-sm btn-primary btn-danger"
                                        (click)="removeOr(filter, or)"
                                    >
                                        <i class="fa fa-trash"></i
                                    ></button>
                                </td>
                            }
                        </tr>
                    }
                </table>
            </td>
            @if (showOrs) {
                <td class="filter-or-button">
                    <button
                        type="button"
                        class="ace-btn btn-sm btn-primary btn-success ws-no-margin"
                        style="white-space: nowrap"
                        (click)="addOr(filter)"
                    >
                        + OR
                    </button>
                </td>
            }
        </tr>
    }
</table>
